<template>
    <section class="sub_page_con wrap_1120 mypage_inqury">
        <div class="search_wrap">
            <input type="text" v-model="state.searchText" @keyup.enter="getSearch" @keyup="getSearch" placeholder="검색어를 입력하세요." />
            <button class="search_btn icon_wrap" @click="getSearch"><img src="img/search_btn.png" alt="" /></button>
        </div>
        <div class="btn_wrap _default float_right _board_type">
            <button v-if="!state.isMobile" class="common_btn _gray" @click="isDelete">삭제</button>
            <a href="javascript:void(0)" class="common_btn w_130" @click="router.push('/inquiryWrite')">글쓰기</a>
        </div>
        <div class="open_board con_board sub_page_con_view">
            <ul>
                <li class="thead_li">
                    <div class="tr_div con_tit">
                        <div class="tb_chk checkbox_wrap2">
                            <input type="checkbox" v-model="state.checkAll" @change="toggleAll()" />
                            <em></em>
                        </div>
                        <div class="tb_no">번호</div>
                        <div class="tb_subject">제목</div>
                        <div class="tb_date_hour">날짜</div>
                    </div>
                </li>

                <li
                    class="tbody_li"
                    v-for="(item, index) in state.list"
                    :key="item.idx"
                    :class="[index === openIndex ? 'active' : '']"
                    v-if="state.list.length > 0"
                >
                    <template v-if="!state.isMobile">
                        <div class="tr_div con_tit" @click="toggle(index)">
                            <div class="tb_chk checkbox_wrap2" @click.stop>
                                <input type="checkbox" v-model="state.checkedList" :value="item.idx" @click.stop />
                            </div>
                            <div class="tb_no">{{ (state.page - 1) * state.size + (index + 1) }}</div>
                            <div class="tb_subject">
                                <div class="elips_1">
                                    <u>{{ item.title }}</u>
                                </div>
                                <span class="ans_complete" :class="{ waiting: item.state !== 1 }">
                                    {{ item.state === 1 ? "답변완료" : "답변대기" }}
                                </span>
                            </div>
                            <div class="tb_date_hour">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</div>
                        </div>

                        <transition name="collapse">
                            <div class="con_desc" v-show="openIndex === index">
                                <div class="con_q">
                                    <span>내용</span>
                                    <div>{{ item.content }}</div>
                                </div>
                                <div class="con_a">
                                    <span>답변</span>
                                    <div>
                                        {{ item.state === 1 ? item.comment : "답변 대기 중입니다." }}
                                    </div>
                                    <p class="con_date">{{ item.state === 1 ? CommonUtils.dateFormat(new Date(item.answerDate), ".", true) : "" }}</p>
                                </div>
                            </div>
                        </transition>
                    </template>
                    <template v-else>
                        <div class="tr_div con_tit small_txt" @click="toggle(index)">
                            <div class="_flex _flex_100 _jc_sb">
                                <div class="tb_subject">
                                    <div class="elips_1">
                                        <u>{{ item.title }}</u>
                                    </div>
                                    <span class="ans_complete" :class="{ waiting: item.state !== 1 }">
                                        {{ item.state === 1 ? "답변완료" : "답변대기" }}
                                    </span>
                                </div>
                                <button class="m_option_btn icon_wrap only_768" @click="optionOpen(item)">
                                    <img src="img/kebabIcon.png" class="" />
                                </button>
                                <div class="m_option_wrap" v-show="state.isShowBtn && state.list_idx === item.idx">
                                    <button type="button" class="_gray" @click="optionClose(item)">삭제</button>
                                </div>
                            </div>
                            <div class="tb_date_hour">{{ CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true) }}</div>
                        </div>

                        <transition name="collapse">
                            <div class="con_desc" v-show="openIndex === index">
                                <div class="con_q">
                                    <span>내용</span>
                                    <div>{{ item.content }}</div>
                                </div>
                                <div class="con_a">
                                    <span>답변</span>
                                    <div>
                                        {{ item.state === 1 ? item.comment : "답변 대기 중입니다." }}
                                    </div>
                                    <p class="con_date">{{ item.state === 1 ? CommonUtils.dateFormat(new Date(item.answerDate), ".", true) : "" }}</p>
                                </div>
                            </div>
                        </transition>
                    </template>
                </li>

                <li v-else class="tbody_li no_data">
                    <div class="tr_div">
                        <div class="tb_subject" style="text-align: center; width: 100%">등록된 게시물이 없습니다.</div>
                    </div>
                </li>
            </ul>
        </div>
        <PageBtn
            v-if="state.list.length !== 0"
            :currentPage="state.page"
            :totalLength="state.totalLength"
            :perPage="state.size"
            @onPaging="handlePageChange"
        ></PageBtn>
    </section>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts" config>
    import {
        Header,
        Footer,
        router,
        ref,
        apiService,
        types,
        reactive,
        onMounted,
        CommonUtils,
        computed,
        ModalDefault,
        watch,
        PageBtn,
        getMessageByCode,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, ModalDefault, PageBtn },
        emits: ["write"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                page: 1 as number,
                size: 10 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                list: [] as Array<types.ResInquiryVOForApi>,
                checkedList: [] as Array<number>,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                checkAll: false as boolean,
                searchText: "" as string,

                isMobile: false,
                isShowBtn: false,
                list_idx: 0 as number,
            });

            onMounted(() => {
                getInquiryList();

                state.isMobile = window.innerWidth < 768;
            });

            watch(
                () => state.checkedList,
                (newVal) => {
                    if (state.list.length !== 0) state.checkAll = newVal.length === state.list.length;
                    else state.checkAll = false;
                },
            );

            const fnEvent = () => {
                emit("write");
            };

            const openIndex = ref(null);
            const toggle = (index: any) => {
                openIndex.value = openIndex.value === index ? null : index;
            };

            const getInquiryList = async () => {
                const param: types.ReqCommonPaging = {
                    page: state.page,
                    size: state.size,
                    searchType: null,
                    searchText: state.searchText,
                };

                const res = await apiService.mypage.inquiryList(param);

                if (res.returnCode === 0) {
                    state.list = res.list.data;

                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const isDelete = () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const deleteCheckList = async () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    const res = await apiService.mypage.inquiryMultiRemove(state.checkedList.join(","));
                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "삭제가 완료되었습니다.";
                        state.isShowModal = true;

                        getInquiryList();
                        state.checkedList = [];
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    deleteCheckList();
                }
            };

            const toggleAll = () => {
                if (state.checkAll) {
                    state.checkedList = state.list.map((item) => item.idx);
                } else {
                    state.checkedList = [];
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getInquiryList();
            };

            const getSearch = () => {
                state.page = 1;
                getInquiryList();
            };
            const optionOpen = (item: any) => {
                if (state.list_idx === item.idx) {
                    state.isShowBtn = false;
                    state.list_idx = 0;
                } else {
                    state.isShowBtn = true;
                    state.list_idx = item.idx;
                }
            };

            const optionClose = (item: any) => {
                state.checkedList = [item.idx];

                isDelete();
            };
            return {
                router,
                fnEvent,
                toggle,
                openIndex,
                state,
                CommonUtils,
                isDelete,
                closeModal,
                callBackModal,
                toggleAll,
                handlePageChange,
                getSearch,
                optionOpen,
                optionClose,
            };
        },
    };
</script>
<style scoped>
    .collapse-enter-active,
    .collapse-leave-active {
        transition: all 0.3s ease;
        overflow: hidden;
    }
    .collapse-enter-from,
    .collapse-leave-to {
        max-height: 0;
        opacity: 0;
    }
    .collapse-enter-to,
    .collapse-leave-from {
        max-height: 500px;
        opacity: 1;
    }

    .ans_complete.waiting {
        background-color: #a5a5a5;
        color: #fff;
    }

    .checkbox_wrap2 em {
        display: none;
    }

    .tbody_li.no_data,
    .tbody_li.no_data .tr_div {
        background: transparent !important;
        cursor: default !important;
    }
    .tbody_li.no_data:hover,
    .tbody_li.no_data .tr_div:hover {
        background: transparent !important;
        cursor: default !important;
    }
</style>
